import { observer } from 'mobx-react-lite'
import type { TaxInfoGatheringViewModel } from '@/features/jobs/details/tax-type/info-gathering/TaxInfoGatheringViewModel'
import {
  BusinessInfoCardListItem,
  EmptyBusinessInfoCardListItem,
  BusinessInfoSection,
  SkeletonChecklistItemCardListItem,
  TaxRefundMethodCardListItem,
  EmptyTaxRefundMethodCardListItem,
} from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistItemsSections/index'
import { formatTaxDeliveryMethodType } from '@/features/tax-profile/tax-refund-methods/delivery-method-formatter'

interface BusinessInfoSectionContainerProps {
  vm: TaxInfoGatheringViewModel
}

/**
 * Business Info Section Container
 */
export const BusinessInfoSectionContainer = observer(
  function BusinessInfoSectionContainer({
    vm,
  }: BusinessInfoSectionContainerProps) {
    if (vm.businessInfoSectionItemVms.length === 0) {
      return null
    }

    return (
      <BusinessInfoSection testId="business-info-section">
        {vm.businessInfoSectionItemVms.map((itemVm) => {
          switch (itemVm.type) {
            case 'BusinessInfo':
              return itemVm.fetch.pending ? (
                <SkeletonChecklistItemCardListItem key={itemVm.type} />
              ) : itemVm.isCompleted ? (
                <BusinessInfoCardListItem
                  key={itemVm.type}
                  businessName={itemVm.businessName}
                  onAction={itemVm.showBusinessProfilesDialog}
                />
              ) : (
                <EmptyBusinessInfoCardListItem
                  key={itemVm.type}
                  onAction={
                    itemVm.isReadOnly
                      ? undefined
                      : itemVm.showBusinessProfilesDialog
                  }
                />
              )
            case 'BusinessTaxRefundMethod':
              return itemVm.fetch.pending ? (
                <SkeletonChecklistItemCardListItem key={itemVm.type} />
              ) : itemVm.isCompleted && itemVm.method ? (
                <TaxRefundMethodCardListItem
                  key={itemVm.type}
                  methodTitle={formatTaxDeliveryMethodType(
                    itemVm.method.deliveryMethod.type,
                  )}
                  onAction={itemVm.showTaxRefundMethodsDialog}
                />
              ) : (
                <EmptyTaxRefundMethodCardListItem
                  kind="business"
                  key={itemVm.type}
                  onAction={
                    itemVm.isReadOnly
                      ? undefined
                      : itemVm.showTaxRefundMethodsDialog
                  }
                />
              )
          }
        })}
      </BusinessInfoSection>
    )
  },
)
